import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getChannelAnalytics } from '../../services'
import { DashboardKeys } from '@/modules/dashboard/keys'
import { GetChannelAnalyticsResponse } from '@/modules/dashboard/type'
import { GetChannelAnalyticsRequest } from '@/modules/dashboard/type'

export default function useQueryGetChannelAnalytic(
	payload: GetChannelAnalyticsRequest,
	props?: UseBaseQueryOptions<GetChannelAnalyticsResponse>,
) {
	return useQuery({
		queryKey: [DashboardKeys.ChaneelAnalytics, payload],
		queryFn: () => getChannelAnalytics(payload),
		...props,
	})
}
